
import { Box } from "@material-ui/core"
import { Grid } from "@mui/material";
import InputDocUpload from "../../../../../../utils/inputFileUpload/inputDocUpload";


export default function DocsSuplementoAlimentarAnexo({ HandleChangeFile }) {
    const imputLigth = true;
    const fullWidth = true;

    return (
        <Box>

            <Grid container>
            <Grid xs={12} sm={6} item>
                    <InputDocUpload
                        imputLigth={imputLigth}
                        fullWidth={fullWidth}
                        onFileSelect={HandleChangeFile}
                        inputName={'solicitacao'}
                        inputDescription={'Solicitação de desalfandegamento dirigida à ARMED'}
                        inputTitle={'Solicitação de desalfandegamento'}
                    />
                </Grid>
                
                <Grid xs={12} sm={6} item>
                    <InputDocUpload
                        imputLigth={imputLigth}
                        fullWidth={fullWidth}
                        onFileSelect={HandleChangeFile}
                        inputName={'cartaPorteBl'}
                        inputDescription={'Carta de porte'}
                        inputTitle={'Carta de porte'}
                    />
                </Grid>

                <Grid xs={12} sm={6} item>
                    <InputDocUpload
                        imputLigth={imputLigth}
                        fullWidth={fullWidth}
                        onFileSelect={HandleChangeFile}
                        inputName={'certificadoOP'}
                        inputDescription={'Certificado de origem'}
                        inputTitle={'Certificado de origem'}
                    />
                </Grid>

                <Grid xs={12} sm={6} item>
                    <InputDocUpload
                        imputLigth={imputLigth}
                        fullWidth={fullWidth}
                        onFileSelect={HandleChangeFile}
                        inputName={'CertificadoAnaliticoLote'}
                        inputDescription={'Certificado análitico por lote'}
                        inputTitle={'Certificado análitico por lote'}
                    />

                </Grid>

                <Grid xs={12} sm={6} item>
                    <InputDocUpload
                        imputLigth={imputLigth}
                        fullWidth={fullWidth}
                        onFileSelect={HandleChangeFile}
                        inputName={'declaracaoExclusividade'}
                        inputDescription={'Declaração de exclusividade'}
                        inputTitle={'Declaração de exclusividade'}
                    />
                </Grid>

                <Grid xs={12} sm={6} item>
                    <InputDocUpload
                        imputLigth={imputLigth}
                        fullWidth={fullWidth}
                        onFileSelect={HandleChangeFile}
                        inputName={'faturaEmolumento'}
                        inputDescription={'Factura de pagamento de emolumento na Armed'}
                        inputTitle={'Factura de pagamento de emolumento na Armed'}
                    />
                </Grid>
                <Grid xs={12} sm={6} item>
                    <InputDocUpload
                        imputLigth={imputLigth}
                        fullWidth={fullWidth}
                        onFileSelect={HandleChangeFile}
                        inputName={'faturaFinal'}
                        inputDescription={'Factura final'}
                        inputTitle={'Factura final'}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}


